<template>
    <!-- desk -->
    <div class="">
        <div class="container-fluid bg-white">
            <p class="text-bat fs-6 py-3 mb-0 text-center">
                Contenido interno y exclusivo para los pertenecientes al programa Conectados, con fines
                educativos. Prohibido compartir o distribuir el material fuera de la plataforma Conectados de
                BAT.
            </p>
        </div>
        <footer class="container-fluid py-5 bg-blueIndigoDark">
            <div class="container text-white text-bat">
                <div class="mb-4 d-flex align-items-center logo-pair">
                    <img :src="logo" alt="logo_footer" width="95px" height="45px" />
                    <a href="https://sedeelectronica.sic.gov.co/" target="_blank" rel="noopener">
                        <img src="/img/brand/logo_superintendencia_ic.svg" alt="logo_superintendencia" height="45px" />
                    </a>
                </div>
                <div class="row mb-4">
                    <div class="col-12">
                        <p class="fs-6 mb-0">
                            {{
                                client_segment !== 0
                                    ? (shopkeeper.includes(client_segment) || staff.includes(client_segment)
                                        ? 'Material dirigido al canal de comercialización. Prohibida su reproducción total o parcial.'
                                        : 'Conecta2 contigo es una herramienta de trabajo. Material de comunicación de uso interno y dirigido a la fuerza de ventas de BAT.')
                                    : 'Material dirigido al canal de comercialización. Prohibida su reproducción total o parcial.'
                            }}
                        </p>
                    </div>
                </div>
                <!-- desk -->
                <div class="row">
                    <div class="footer-desk">
                        <div class="col-12 col-md-12 col-lg-4 col-xl-4 order-0">
                            <div class="mb-2">
                                <a class="fs-6 text-title-bat text-white text-decoration-none" target="_blank" rel="noopener noreferrer" href="https://sedeelectronica.sic.gov.co/">
                                    Superintendencia de Industria y Comercio
                                </a>
                            </div>
                            <div class="mb-2">
                                 <a class="fs-6 text-title-bat text-white text-decoration-none" target="_blank" rel="noopener noreferrer" href="https://www.batcolombia.com/meta/footer/aviso-de-privacidad">
                                    Aviso de privacidad
                                </a>
                            </div>
                            <div class="mb-2">
                                <a class="fs-6 text-title-bat text-white text-decoration-none" target="_blank" rel="noopener noreferrer" href="https://www.batcolombia.com/meta/footer/politica-de-privacidad">
                                    Política de privacidad
                                </a>
                            </div>
                            <div class="mb-2">
                                <a class="fs-6 text-title-bat text-white text-decoration-none" target="_blank" rel="noopener noreferrer" :href="tyc">
                                    Términos y condiciones de uso
                                </a>
                            </div>
                            <div v-if="client_segment !== 0" class="mb-2">
                                <a class="fs-6 text-title-bat text-white text-decoration-none" href="/preguntas-frecuentes">
                                    FAQ
                                </a>
                            </div>
                            <div v-if="segments_delete_account && segments_delete_account.includes(client_segment)" >
                                <a class="fs-6 text-title-bat text-white text-decoration-none" href="/account/delete">
                                    Cancelar suscripción
                                </a>
                            </div>
                        </div>
                        <div class="col-12 col-md-12 col-lg-4 col-xl-4 order-1">
                            <div>
                                <p class="fs-6">
                                    Líneas de atención <strong>GRATUITA</strong> #551 <br> Desde cualquier celular 018000122040
                                </p>
                            </div>
                            <div>
                                <p class="fs-6">
                                    Para consultas sobre protección de datos <br>personales: <br>
                                    <a class="fs-6 text-title-bat text-white text-decoration-none" href="mailto:datospersonales_colombia@bat.com">
                                        datospersonales_colombia@bat.com
                                    </a>
                                </p>
                            </div>
                            <div>
                                <p class="fs-6">
                                    Canal de atención directa PQRS:
                                    <a class="fs-6 text-title-bat text-white text-decoration-none" href="mailto:servicioalcliente@bat.com">
                                        servicioalcliente@bat.com
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div class="col-12 col-md-12 col-lg-4 col-xl-4 order-2">
                            <div class="">
                                <p class="fs-6 mb-2">
                                    {{ year }} © BAT Colombia. Todos los derechos reservados.
                                </p>
                            </div>
                            <div class="">
                                <p class="fs-6 mb-2">
                                    NIT: <strong>900462511</strong>
                                </p>
                            </div>
                            <div class="">
                                <p class="fs-6 mb-2">
                                    Razón social:<strong> British American Tobacco SAS</strong>
                                </p>
                            </div>
                            <div class="">
                                <p class="fs-6 mb-2">
                                    Dirección para notificaciones judiciales:
                                    <strong>Av. carrera 72 #80-94, piso 9</strong>
                                </p>
                            </div>
                            <div class="">
                                <p class="fs-6 mb-0">
                                    Correo electrónico para notificaciones judiciales:
                                    <a class="fs-6 text-white text-decoration-none" href="mailto:alexandra_bernal@bat.com">
                                        <strong>alexandra_bernal@bat.com</strong>
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- mobile -->
                <div class="row">
                    <div class="footer-mobile">
                        <div class="accordion accordion-flush" id="accordionFooter">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="heading-legal-information">
                                    <button class="accordion-button footer-button-accordion" type="button" data-bs-toggle="collapse" data-bs-target="#legal-information" aria-expanded="false" aria-controls="legal-information">
                                        Información Legal
                                    </button>
                                </h2>
                                <div id="legal-information" class="accordion-collapse collapse show" aria-labelledby="heading-legal-information" data-bs-parent="#accordionFooter">
                                    <div class="accordion-body">
                                        <div class="col-12 col-md-12" >
                                            <div class="mb-2">
                                                <a class="style-text-accordion-body text-title-bat text-white text-decoration-none" target="_blank" rel="noopener noreferrer" href="https://sedeelectronica.sic.gov.co/">
                                                    Superintendencia de Industria y Comercio
                                                </a>
                                            </div>
                                            <div class="mb-2" :class="{'mb-3': client_segment === 0}">
                                                <a class="style-text-accordion-body text-title-bat text-white text-decoration-none" target="_blank" rel="noopener noreferrer" :href="tyc">
                                                    Términos y condiciones de uso
                                                </a>
                                            </div>
                                            <div v-if="client_segment !== 0" class="mb-2" :class="{'mb-3' : !segments_delete_account && !segments_delete_account.includes(client_segment)}">
                                                <a class="style-text-accordion-body text-title-bat text-white text-decoration-none" href="/preguntas-frecuentes">
                                                    FAQ
                                                </a>
                                            </div>
                                            <div v-if="segments_delete_account && segments_delete_account.includes(client_segment)" class="mb-3">
                                                <a class="style-text-accordion-body text-title-bat text-white text-decoration-none" href="/account/delete">
                                                    Cancelar suscripción
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="heading-customer-service">
                                    <button class="accordion-button collapsed footer-button-accordion" type="button" data-bs-toggle="collapse" data-bs-target="#customer-service" aria-expanded="false" aria-controls="customer-service">
                                        Atención al cliente
                                    </button>
                                </h2>
                                <div id="customer-service" class="accordion-collapse collapse" aria-labelledby="heading-customer-service" data-bs-parent="#accordionFooter">
                                    <div class="accordion-body">
                                        <div class="col-12 col-md-12" >
                                            <div class="text-white">
                                                <p class="style-text-accordion-body">
                                                    Líneas de atención <strong>GRATUITA</strong> #551 Desde cualquier celular 018000122040
                                                </p>
                                            </div>
                                            <div class="text-white">
                                                <p class="style-text-accordion-body">
                                                    Canal de atención directa PQRS:
                                                    <a class="style-text-accordion-body text-title-bat text-white text-decoration-none" href="mailto:servicioalcliente@bat.com">
                                                        servicioalcliente@bat.com
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="heading-policy-and-privacy">
                                    <button class="accordion-button collapsed footer-button-accordion" type="button" data-bs-toggle="collapse" data-bs-target="#policy-and-privacy" aria-expanded="false" aria-controls="policy-and-privacy">
                                        Protección de datos
                                    </button>
                                </h2>
                                <div id="policy-and-privacy" class="accordion-collapse collapse" aria-labelledby="heading-policy-and-privacy" data-bs-parent="#accordionFooter">
                                    <div class="accordion-body">
                                        <div class="col-12 col-md-12">
                                            <div class="mb-2">
                                                <a class="style-text-accordion-body text-title-bat text-white text-decoration-none" target="_blank" rel="noopener noreferrer" href="https://www.batcolombia.com/meta/footer/aviso-de-privacidad">
                                                    Aviso de privacidad
                                                </a>
                                            </div>
                                            <div class="mb-2">
                                                <a class="style-text-accordion-body text-title-bat text-white text-decoration-none" target="_blank" rel="noopener noreferrer" href="https://www.batcolombia.com/meta/footer/politica-de-privacidad">
                                                    Política de privacidad
                                                </a>
                                            </div>
                                            <div>
                                                <p class="style-text-accordion-body">
                                                    Para consultas sobre protección de datos personales:
                                                    <a class="style-text-accordion-body text-title-bat text-white text-decoration-none" href="mailto:datospersonales_colombia@bat.com">
                                                        <strong>datospersonales_colombia@bat.com</strong>
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="heading-judicial-notifications">
                                    <button class="accordion-button collapsed footer-button-accordion" type="button" data-bs-toggle="collapse" data-bs-target="#judicial-notifications" aria-expanded="false" aria-controls="judicial-notifications">
                                        Notificaciones Judiciales
                                    </button>
                                </h2>
                                <div id="judicial-notifications" class="accordion-collapse collapse" aria-labelledby="heading-judicial-notifications" data-bs-parent="#accordionFooter">
                                    <div class="accordion-body">
                                        <div class="col-12 col-md-12 " >
                                            <div class="">
                                                <p class="style-text-accordion-body mb-3">
                                                    Dirección:
                                                    <strong>Av. carrera 72 #80-94, piso 9</strong>
                                                </p>
                                            </div>
                                            <div class="">
                                                <p class="style-text-accordion-body">
                                                    Correo electrónico:<br>
                                                    <a class="style-text-accordion-body text-white text-decoration-none" href="mailto:alexandra_bernal@bat.com">
                                                        <strong>alexandra_bernal@bat.com</strong>
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                        </div>
                        <div class="out-accordion">
                            <div class="col-12 col-md-12 " >
                                <div class="">
                                    <p class="fs-6 mb-2">
                                        {{ year }} © BAT Colombia. Todos los derechos reservados.
                                    </p>
                                </div>
                                <div class="">
                                    <p class="fs-6 mb-1">
                                        NIT: <strong>900462511</strong>
                                    </p>
                                </div>
                                <div class="">
                                    <p class="fs-6 mb-1">
                                        Razón social:<strong> British American Tobacco SAS</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <br>
                    </div>
                </div>
            </div>
            <br>
        </footer>
    </div>
</template>

<script>
    export default {
        props:{
            client_segment: {
                type: Number,
                default: null,
            },
            segments_delete_account:{
                default: [],
            },
            tyc_sellers:{
                default: [],
            },
            shopkeeper:{
                default: [],
            },
            staff: {
                default: [],
            },
        },
        data(){
            return{
                year: new Date().getFullYear()
            }
        },
        computed: {
            logo() {
                if (this.client_segment === 0 || this.shopkeeper.includes(this.client_segment)|| this.staff.includes(this.client_segment)) {
                    return '/img/brand/logo_header_newlook_footer.svg';
                }
                return '/img/brand/logo_newlook_contigo_footer.svg';
            },
            tyc(){
                if (this.client_segment === 0 || this.shopkeeper.includes(this.client_segment)) {
                    return '/download/tyc_conecta2.pdf'
                }
                if(this.staff.includes(this.client_segment)) {
                    return '/download/tyc_staff.pdf'
                }
                return '/download/terminos_y_condiciones_programa_conecta2.pdf'
            },
        },
        mounted() {
        }
    }
</script>
